import { createRouter, createWebHistory } from 'vue-router';

import {
  authenticationService
} from '@/_services';
import {
  Role
} from './role.js';

import HomePage from '../home/HomePage'
import LoginPage from '../login/LoginPage'
import RegisterPage from '../login/RegisterPage'
import ChangePasswordPage from '../login/ChangePasswordPage'
import datepicker from 'vuejs3-datepicker';
//import VueMonthlyPicker from 'vue-monthly-picker';
//Vue.component('month-picker', VueMonthlyPicker);


//import Admin from '../admin/Admin.vue'

const ResetPasswordRequest = require('../login/ResetPasswordRequest.vue').default;
const ResetEmailSubmitted = require('../login/ResetEmailSubmitted.vue').default;
const SuccessfulResetPassword = require('../login/SuccessfulResetPassword.vue').default;
const ForgotPassword = require('../login/ForgotPassword.vue').default;
const SuccessfulActivation = require('../login/SuccessfulActivation.vue').default;
const ConfirmAccount = require('../login/ConfirmAccount.vue').default;
const ConfirmProperty = require('../login/ConfirmProperty.vue').default;
const Buildings = require('../admin/Buildings.vue').default;
const Complex = require('../admin/Complex.vue').default;
const Properties = require('../admin/Properties.vue').default;
const Property = require('../admin/Property.vue').default;
const AdditionalIndex = require('../admin/AdditionalIndex.vue').default;
const ExpensesIndex = require('../admin/ExpensesIndex.vue').default;
const AdditionalDetail = require('../admin/AdditionalDetail.vue').default;
const RecurringExpenses = require('../admin/RecurringExpenses.vue').default;
const RecurringExpense = require('../admin/RecurringExpense.vue').default;
const ExpensesByMonth = require('../admin/ExpensesByMonth.vue').default;
const Payments = require('../admin/Payments.vue').default;
const CreditNotes = require('../admin/CreditNotes.vue').default;
const CreditNotesExpenses = require('../admin/CreditNotesExpenses.vue').default;
const Invoices = require('../admin/Invoices.vue').default;
const PaymentsOwner = require('../owner/Payments.vue').default;
const PropertiesOwner = require('../owner/Properties.vue').default;
const Receipt = require('../admin/Receipt.vue').default;
const Committees = require('../admin/Committees.vue').default;
const Committee = require('../admin/Committee.vue').default;
const Suppliers = require('../admin/Suppliers.vue').default;
const Supplier = require('../admin/Supplier.vue').default;
const Contacts = require('../admin/Contacts.vue').default;
const Contact = require('../admin/Contact.vue').default;
//const Messages = Vue.component('messages',require('../admin/Messages.vue').default);
const Messages = require('../admin/MessagesNew.vue').default;
const MessagesOwner = require('../owner/MessagesNew.vue').default;
//const UnderConstruction = Vue.component('messages', require('../admin/UnderConstruction.vue').default);
const Message = require('../admin/Message.vue').default;
const MessageOwner = require('../owner/Message.vue').default;
const Building = require('../admin/Building.vue').default;
const MorePage = require('../admin/MorePage.vue').default;
const ControlPanel = require('../admin/ControlPanel.vue').default;
const ControlPanelOwner = require('../owner/ControlPanel.vue').default;
const Revenues = require('../admin/Revenues.vue').default;
const ExpensesReport = require('../admin/ExpensesReport.vue').default;
const CashDeposit = require('../admin/CashDeposit.vue').default;
const UserStatement = require('../admin/UserStatement.vue').default;
const CreditorStatement = require('../admin/CreditorStatement.vue').default;
const CreditorPaymentStatement = require('../admin/CreditorPaymentStatement.vue').default;
const UserStatementOwner = require('../owner/UserStatement.vue').default;
const Users = require('../admin/Users.vue').default;
const Settings = require('../admin/Settings.vue').default;
const User = require('../admin/User.vue').default;
const Account = require('../admin/Account.vue').default;
const UserBuildings = require('../admin/UserBuildings.vue').default;
const UserBuilding = require('../admin/UserBuilding.vue').default;
const SaferPay = require('../owner/SaferPay.vue').default;
const G60 = require('../admin/Statement.vue').default;
const G61 = require('../admin/PropertyStatement.vue').default;
const G62 = require('../admin/Expenses.vue').default;
const G63 = require('../admin/TotalExpenses.vue').default;
const G64 = require('../admin/ExpenseFormLink.vue').default;
const G65 = require('../admin/AdditionalExpenseFormLink.vue').default;
const G66 = require('../admin/ExpenseForm.vue').default;
const AdditionalExpense = require('../admin/AdditionalExpenseForm.vue').default;
const G67 = require('../admin/CreditorFormLink.vue').default;
const G68 = require('../admin/Creditors.vue').default;
const G69 = require('../admin/ExpensePaymentForm.vue').default;
const G70 = require('../admin/Collected.vue').default;
const G71 = require('../admin/Income.vue').default;
const G72 = require('../admin/TotalIncome.vue').default;
const G73 = require('../admin/PropertyExpense.vue').default;
const G74 = require('../admin/PropertyExpenses.vue').default;
const G75 = require('../admin/DebtorFormLink.vue').default;
const G76 = require('../admin/CollectPaymentForm.vue').default;
const G77 = require('../admin/CollectMonthlyPaymentForm.vue').default;
const G78 = require('../admin/DebtorMonthlyFormLink.vue').default;
const G79 = require('../admin/UnCollected.vue').default;
const G80 = require('../admin/Outstanding.vue').default;
const ExpenseTypes = require('../admin/ExpenseTypes.vue').default;
const ExpenseType = require('../admin/ExpenseType.vue').default;
//const LoginPage = Vue.component('login-page',require('./login/LoginPage.vue').default);
const G81 = require('../admin/AdminNavbar.vue').default;
const G82 = require('../admin/AdminFooter.vue').default;
const G83 = require('../admin/SideMenu.vue').default;
const G84 = require('../admin/OwnerMenu.vue').default;
const G85 = require('../admin/NavMenu.vue').default;
const G86 = require('../admin/Burger.vue').default;
const G87 = require('../app/TermsAndConditions.vue').default;
const G88 = require('../app/PrivacyPolicy.vue').default;
const G89 = require('../app/Disclaimer.vue').default;
const G90 = require('../app/submissionFailure.vue').default;
const G91 = require('../app/emptyModal.vue').default;
const G92 = require('../admin/DeleteAlert.vue').default;
const G93 = require('../admin/UserMenu.vue').default;
const G94 = require('../admin/ControlPanelAdd.vue').default;
const G95 = require('../admin/SendInvoice.vue').default;
const G96 = require('../admin/SendReceipt.vue').default;
const G97 = require('../components/GraphReportsTotals.vue').default;
const G98 = require('../admin/CreditNoteMonthlyForm.vue').default;
const G99 = require('../admin/CreditNoteAdditionalExpensesForm.vue').default;
const G100 = require('../admin/CreditNoteAdditionalForm.vue').default;
const G101 = require('../admin/CreditNoteExpensesForm.vue').default;
 
const Invoice = require('../components/Invoice.vue').default;
const G102 = require('../admin/Slide.vue').default;
const RegisterAdministration = require('../app/RegisterAdministration.vue').default;
const PrivacyPolicy = require('../app/PrivacyPolicyPage.vue').default;
const JobOfferWebDeveloper = require('../app/JobOfferWebDeveloper.vue').default;
const JobOfferCustomerService = require('../app/JobOfferCustomerService.vue').default;

// Components that templates use by tag name without importing them
export const globalComponents = {
  "resetpasswordrequest": ResetPasswordRequest,
  "resetemail": ResetEmailSubmitted,
  "successfulreset": SuccessfulResetPassword,
  "forgotpassword": ForgotPassword,
  "successfulactivation": SuccessfulActivation,
  "confirmaccount": ConfirmAccount,
  "confirmproperty": ConfirmProperty,
  "buildings": Buildings,
  "complex": Complex,
  "properties": Property,
  "additional-index": RecurringExpenses,
  "expenses-index": ExpensesIndex,
  "additional-detail": RecurringExpense,
  "expenses-by-month": ExpensesByMonth,
  "payments": Receipt,
  "credit-notes": CreditNotes,
  "credit-notes-expenses": CreditNotesExpenses,
  "invoices": Invoices,
  "payments-owner": PaymentsOwner,
  "properties-owner": PropertiesOwner,
  "committees": Committees,
  "committee": Committee,
  "suppliers": Suppliers,
  "supplier": Supplier,
  "contacts": Contacts,
  "contact": Contact,
  "messages": MessagesOwner,
  "message": MessageOwner,
  "building": Building,
  "more-page": MorePage,
  "control-panel": ControlPanel,
  "control-panel-owner": ControlPanelOwner,
  "revenues": CashDeposit,
  "userstatement": Account,
  "creditorstatement": CreditorStatement,
  "creditorpaymentstatement": CreditorPaymentStatement,
  "userstatement-owner": UserStatementOwner,
  "settings": Settings,
  "userbuildings": UserBuilding,
  "saferpay": SaferPay,
  "statement": G60,
  "propertystatement": G61,
  "expenses": G62,
  "total-expenses": G63,
  "expense-form-link": G64,
  "additional-expense-form-link": G65,
  "expense-form": G66,
  "additional-expense-form": AdditionalExpense,
  "creditor-form-link": G67,
  "creditors": G68,
  "expensepayment-form": G69,
  "collected": G70,
  "income": G71,
  "total-income": G72,
  "property-expense": G73,
  "property-expenses": G74,
  "debtor-form-link": G75,
  "collectpayment-form": G76,
  "collect-monthly-payment-form": G77,
  "debtor-monthly-form-link": G78,
  "uncollected": G79,
  "outstanding": G80,
  "expense-types": ExpenseType,
  "admin-navbar": G81,
  "admin-footer": G82,
  "side-menu": G83,
  "owner-menu": G84,
  "nav-menu": G85,
  "burger": G86,
  "terms-and-conditions": G87,
  "privacy-policy": G88,
  "disclaimer": G89,
  "submissionFailure": G90,
  "emptyModal": G91,
  "deleteAlert": G92,
  "userMenu": G93,
  "control-panel-add": G94,
  "send-invoice": G95,
  "send-receipt": G96,
  "graph-reports-totals": G97,
  "creditnote-monthly-form": G98,
  "creditnote-additionalexpense-form": G99,
  "creditnote-additional-form": G100,
  "creditnote-expenses-form": G101,
  "invoice": Invoice,
  "slide": G102,
  "registerAdministration": RegisterAdministration,
  "privacypolicy": PrivacyPolicy,
  "jobOfferWebDeveloper": JobOfferWebDeveloper,
  "jobOfferCustomerService": JobOfferCustomerService,
  'date-picker': datepicker
};


export const router = createRouter({
  history: createWebHistory(),
  routes: [{
      path: '/',
      name: 'homepage',
      component: HomePage
    },
    {
      path: '/registerbuilding',
      name: 'registerbuilding',
      component: RegisterAdministration
      },
      {
          path: '/privacy',
          name: 'privacypolicy',
          component: PrivacyPolicy
      },
    {
      path: '/careers/webdeveloper',
      name: 'careerswebdeveloper',
      component: JobOfferWebDeveloper
    },
    {
      path: '/careers/customerservice',
      name: 'careerscustomerservice',
      component: JobOfferCustomerService
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/register',
      name: 'register',
      component: RegisterPage
      },
      {
          path: '/changepassword/:token',
          name: 'changepassword',
          component: ChangePasswordPage
      },
    {
      path: '/confirmaccount/:token',
      name: 'confirmaccount',
      component: ConfirmAccount
    },
    {
      path: '/successfulactivation/:token',
      name: 'successfulactivation',
      component: SuccessfulActivation
      },
      {
          path: '/successfulreset/:token',
          name: 'successfulreset',
          component: SuccessfulResetPassword
      },
    {
      path: '/forgotpassword/:token',
      name: 'forgotpassword',
      component: ForgotPassword
    },
    {
      path: '/users/resetpasswordrequest/:token?',
      name: 'resetpasswordrequest',
      component: ResetPasswordRequest
      },
      {
          path: '/resetemail',
          name: 'resetemail',
          component: ResetEmailSubmitted
      },
    {
      path: '/confirmproperty/:token',
      name: 'confirmproperty',
      component: ConfirmProperty
    },
    {
      path: '/buildings',
      name: 'buildings',
      component: Buildings,
      meta: {
        authorize: [Role.Admin, Role.Management]
      }
    },
    {
      path: '/complex/:buildingId',
      name: 'complex',
      component: Complex,
      meta: {
        authorize: [Role.Admin, Role.Management]
      }
    },
    {
      path: '/buildings/properties/:buildingId',
      name: 'properties',
      component: Properties,
      meta: {
        authorize: []
      }
    },

    {
      path: '/buildings/properties/property/:propertyId?',
      name: 'property',
      component: Property,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/properties/payments/:buildingId/:propertyId',
      name: 'payments',
      component: Payments,
      meta: {
        authorize: []
      }
      },
      {
          path: '/buildings/properties/creditnotes/:buildingId/:paymentId',
          name: 'credit-notes',
          component: CreditNotes,
          meta: {
              authorize: []
          }
      },
      {
          path: '/buildings/creditnotes/:buildingId/:expenseId',
          name: 'credit-notes-expenses',
          component: CreditNotesExpenses,
          meta: {
              authorize: []
          }
      },
      {
          path: '/buildings/properties/invoices/:buildingId/:propertyId',
          name: 'invoices',
          component: Invoices,
          meta: {
              authorize: []
          }
      },
    {
      path: '/owner/payments/:propertyId',
      name: 'paymentsowner',
      component: PaymentsOwner,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/properties/payments/receipt/:buildingId/:propertyId',
      name: 'receipt',
      component: Receipt,
      meta: {
        authorize: []
      }
    },
    {
      path: '/owner/properties/payments/receipt/:buildingId/:propertyId',
      name: 'receiptowner',
      component: Receipt,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/properties/userstatement/:propertyId',
      name: 'userstatement',
      component: UserStatement,
      meta: {
        authorize: []
      }

    },
    {
      path: '/buildings/creditorstatement/:buildingId/:creditorId',
      name: 'creditorstatement',
      component: CreditorStatement,
      meta: {
        authorize: []
      }

      },
      {
          path: '/buildings/creditorstatement/:buildingId/:creditorId/payments',
          name: 'creditorpaymentstatement',
          component: CreditorPaymentStatement,
          meta: {
              authorize: []
          }

      },
    {
      path: '/owner/userstatement/:propertyId',
      name: 'userstatementowner',
      component: UserStatementOwner,
      meta: {
        authorize: []
      }

    },
    {
      path: '/owner/properties',
      name: 'propertiesowner',
      component: PropertiesOwner,
      meta: {
        authorize: []
      }

    },
    {
      path: '/buildings/controlpanel/:buildingId',
      name: 'controlpanel',
      component: ControlPanel,
      meta: {
        authorize: [Role.Admin, Role.Management]
      }
    },
    {
      path: '/owner/controlpanel/:propertyId',
      name: 'controlpanelowner',
      component: ControlPanelOwner,
      meta: {
        authorize: [Role.Owner, Role.Admin]
      }
    },
    {
      path: '/owner/saferpay/:propertyId',
      name: 'saferpay',
      component: SaferPay,
      meta: {
        authorize: [Role.Owner, Role.Admin]
      }
    },
    {
      path: '/owner/messages/:propertyId',
      name: 'messagesowner',
      component: MessagesOwner,
      meta: {
        authorize: [Role.Owner, Role.Admin]
      }
    },
    {
      path: '/owner/messages/message/:propertyId',
      name: 'messageowner',
      component: MessageOwner,
      meta: {
        authorize: [Role.Owner, Role.Admin]
      }
    },
    {
      path: '/buildings/revenues/:buildingId',
      name: 'revenues',
      component: Revenues,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/expensesreport/:buildingId',
      name: 'expensesreport',
      component: ExpensesReport,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/cashdeposit/:buildingId',
      name: 'cashdeposit',
      component: CashDeposit,
      meta: {
        authorize: []
      }
    },

    {
      path: '/owner/revenues/:propertyId',
      name: 'revenuesowner',
      component: Revenues,
      meta: {
        authorize: []
      }
    },
    {
      path: '/owner/expensesreport/:propertyId',
      name: 'expensesreportowner',
      component: ExpensesReport,
      meta: {
        authorize: []
      }
    },
    {
      path: '/owner/cashdeposit/:propertyId',
      name: 'cashdepositowner',
      component: CashDeposit,
      meta: {
        authorize: []
      }
      },
      {
          path: '/owner/invoice/:invoiceId',
          name: 'invoiceowner',
          component: Invoice,
          meta: {
              authorize: []
          }
      },
      
    {
        path: '/admin/invoice/:invoiceId',
        name: 'invoice',
        component: Invoice,
        meta: {
            authorize: []
        }
    },


    {
      path: '/buildings/messages/:buildingId',
      name: 'messages',
      component: Messages,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/messages/message',
      name: 'message',
      component: Message,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/recurringexpenses/:buildingId',
      name: 'recurringexpenses',
      component: RecurringExpenses,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/recurringexpenses/recurringexpense',
      name: 'recurringexpense',
      component: RecurringExpense,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/additionalexpenses/:buildingId',
      name: 'additionalindex',
      component: AdditionalIndex,
      meta: {
        authorize: []
      }
      },
      {
          path: '/buildings/expensesindex/:expenseId',
          name: 'expensesIndex',
          component: ExpensesIndex,
          meta: {
              authorize: []
          }
      },
    // heeeeeeeeeeeeeeeeeeeeeeeeeeere
    {
      path: '/buildings/additionalexpenses/additionalexpense',
      name: 'additionalexpense',
      component: AdditionalExpense,
      meta: {
        authorize: []
      }
    },

    {
      path: '/buildings/additionalreports/:buildingId',
      name: 'expensesbymonth',
      component: ExpensesByMonth,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/additionalexpenses/detail/:buildingId/:expenseId',
      name: 'additionaldetail',
      component: AdditionalDetail,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/committees/:buildingId',
      name: 'committees',
      component: Committees,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/committees/committee',
      name: 'committee',
      component: Committee,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/suppliers/:buildingId',
      name: 'suppliers',
      component: Suppliers,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/suppliers/supplier',
      name: 'supplier',
      component: Supplier,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/contacts/:buildingId',
      name: 'contacts',
      component: Contacts,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/contacts/contact',
      name: 'contact',
      component: Contact,
      meta: {
        authorize: []
      }
    },
    {
      path: '/admin/building/:id?',
      name: 'building',
      component: Building,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/more/:buildingId',
      name: 'more',
      component: MorePage,
      meta: {
        authorize: []
      }
    },
    {
      path: '/buildings/expenseTypes/:buildingId',
      name: 'expensetypes',
      component: ExpenseTypes,
      meta: {
        authorize: []
      }
    },
    {
      path: '/management/users',
      name: 'users',
      component: Users,
      meta: {
        authorize: [Role.Admin]
      }
      },
      {
          path: '/management/settings',
          name: 'settings',
          component: Settings,
          meta: {
              authorize: []
          }
      },
    {
      path: '/management/users/user',
      name: 'user',
      component: User,
      meta: {
        authorize: [Role.Admin]
      }
    },
    {
      path: '/management/users/account',
      name: 'account',
      component: Account,
      meta: {
        authorize: []
      }
    },
    {
      path: '/management/users/user/buildings',
      name: 'userbuildings',
      component: UserBuildings,
      meta: {
        authorize: [Role.Admin]
      }
    },
    {
      path: '/management/users/user/buildings/building',
      name: 'userbuilding',
      component: UserBuilding,
      meta: {
        authorize: [Role.Admin]
      }
    },
    {
      path: '/buildings/expenseTypes/expenseType',
      name: 'expensetype',
      component: ExpenseType,
      meta: {
        authorize: []
      }
    },

    // otherwise redirect to home
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  linkActiveClass: "active"
});

// Vue Router 3 compatibility: v3 accepted params that are not part of the route path
// (e.g. buildingName, propertyName) and did not throw for links with missing params.
// v4 discards the former and throws on the latter, so keep the old behaviour here.
const rawResolve = router.resolve.bind(router)
const rawPush = router.push.bind(router)
const rawReplace = router.replace.bind(router)
let pendingExtraParams = {}

// v3 compared params loosely (54 and "54" matched); v4 compares strictly, which broke the
// active menu highlight when a link used a number and the URL gave a string. Path params
// are therefore always passed as strings.
function normalizeParams (to) {
  if (!to || typeof to !== 'object' || !to.params) return to
  let known = {}
  try {
    known = rawResolve(to).params
  } catch (e) {
    known = {}
  }
  const params = Object.assign({}, to.params)
  Object.keys(params).forEach(key => {
    if (key in known && typeof params[key] === 'number') params[key] = String(params[key])
  })
  return Object.assign({}, to, { params })
}

router.resolve = (to, currentLocation) => {
  try {
    return rawResolve(normalizeParams(to), currentLocation)
  } catch (e) {
    if (e && /Missing required param/.test(e.message)) return rawResolve('/')
    throw e
  }
}

function stashExtraParams (to) {
  pendingExtraParams = {}
  if (to && typeof to === 'object' && to.params) {
    let known = {}
    try {
      known = rawResolve(to).params
    } catch (e) {
      known = {}
    }
    Object.keys(to.params).forEach(key => {
      if (!(key in known)) pendingExtraParams[key] = to.params[key]
    })
  }
}

router.push = to => {
  stashExtraParams(to)
  return rawPush(normalizeParams(to))
}
router.replace = to => {
  stashExtraParams(to)
  return rawReplace(normalizeParams(to))
}

router.beforeEach((to, from, next) => {
  Object.assign(to.params, pendingExtraParams)
  pendingExtraParams = {}
  // redirect to login page if not logged in and trying to access a restricted page
  const {
    authorize
  } = to.meta;
  const currentUser = authenticationService.currentUserValue;
  //console.log(currentUser)
  if (authorize) {
    if (!currentUser) {
      // not logged in so redirect to login page with the return url
      return next({
        path: '/login',
        query: {
          returnUrl: to.path
        }
      });
    }

    // check if route is restricted by role
    if (authorize.length && !authorize.includes(currentUser.role)) {
      // role not authorised so redirect to home page
      if (currentUser.role === "Owner")
        return next({
          name: 'propertiesowner'
        });
      else
        return next({
          path: '/buildings'
        });
    }
  }

  next();
})

/*router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login','/register'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');
console.log(authRequired);
  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
})*/
